import { ErrorOutline, TaskAlt } from '@mui/icons-material';
import { Grid2, Typography } from '@mui/material';

import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import { ChatInfoBox } from '../ChatInfoBox';

interface ChatInterfaceInfoContainerProps {
  leftAction?: ReactNode;
  rightAction?: ReactNode;
}

export const ChatInterfaceInfoContainer = ({
  leftAction,
  rightAction
}: ChatInterfaceInfoContainerProps) => {
  const { t } = useTranslation();
  return (
    <Grid2 container spacing={5} maxWidth={1000}>
      <Grid2
        container
        size={{ xs: 12, lg: 6 }}
        flexDirection={'column'}
        gap={2}
        alignItems={'center'}
      >
        <Grid2 container flexDirection={'column'} alignItems={'center'} spacing={1}>
          <TaskAlt style={{ color: 'green' }} />
          <Typography variant="h5">{t(translations.pages.chat.possibilities())}</Typography>
        </Grid2>
        <Grid2 container justifyContent={'center'} gap={2} maxWidth={470} sx={{ flex: 1 }}>
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.multiModelSupport.title())}
            text={t(translations.pages.chat.infoBoxes.multiModelSupport.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.chatHistory.title())}
            text={t(translations.pages.chat.infoBoxes.chatHistory.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.fileUpload.title())}
            text={t(translations.pages.chat.infoBoxes.fileUpload.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.pluginsAndTools.title())}
            text={t(translations.pages.chat.infoBoxes.pluginsAndTools.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.privacy.title())}
            text={t(translations.pages.chat.infoBoxes.privacy.text())}
          />
        </Grid2>
      </Grid2>
      <Grid2
        container
        size={{ xs: 12, lg: 6 }}
        flexDirection={'column'}
        gap={2}
        alignItems={'center'}
      >
        <Grid2 container flexDirection={'column'} alignItems={'center'} spacing={1}>
          <ErrorOutline style={{ color: 'red' }} />
          <Typography variant="h5">{t(translations.pages.chat.limitations())}</Typography>
        </Grid2>
        <Grid2 container justifyContent={'center'} gap={2} maxWidth={470} sx={{ flex: 1 }}>
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.knowledgeLimits.title())}
            text={t(translations.pages.chat.infoBoxes.knowledgeLimits.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.hallucinations.title())}
            text={t(translations.pages.chat.infoBoxes.hallucinations.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.performance.title())}
            text={t(translations.pages.chat.infoBoxes.performance.text())}
          />
          <ChatInfoBox
            headline={t(translations.pages.chat.infoBoxes.languageQuality.title())}
            text={t(translations.pages.chat.infoBoxes.languageQuality.text())}
          />
        </Grid2>
      </Grid2>
      {(leftAction || rightAction) && (
        <Grid2 container size={12} justifyContent="center">
          <Grid2
            size={{ xs: 12, lg: 6 }}
            display="flex"
            justifyContent={{ xs: 'center', lg: 'flex-end' }}
          >
            {leftAction}
          </Grid2>
          <Grid2
            size={{ xs: 12, lg: 6 }}
            display="flex"
            justifyContent={{ xs: 'center', lg: 'flex-start' }}
          >
            {rightAction}
          </Grid2>
        </Grid2>
      )}
    </Grid2>
  );
};
